import React, { useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { NoImage } from "../Images";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import { getGalleryData } from "../Service/ApiFunction";
export const Gallery = () => {
  const [gallery, setAllGallery] = useState([]);
  const [imageToShow, setImageToShow] = useState("");

  const [lightboxDisplay, setLightBoxDisplay] = useState(false);

  const getGallery = async () => {
    const responseGallery = await getGalleryData();

    setAllGallery(responseGallery?.data);
  };

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    getGallery();
  }, []);

  //-------------------------------------------------------------------------------------

  useEffect(() => {
    function handleKey(e) {
      if (e.key == "ArrowLeft" || e.key == "ArrowRight") {
        e.preventDefault();
        if (e.key == "ArrowLeft") {
          let currentIndex = gallery?.findIndex(
            (ele) => ele?.id == imageToShow?.id
          );

          if (currentIndex <= 0) {
            setLightBoxDisplay(false);
          } else {
            let nextImage = gallery[currentIndex - 1];
            setImageToShow(nextImage);
          }
        }

        if (e.key == "ArrowRight") {
          let currentIndex = gallery?.findIndex(
            (ele) => ele?.id == imageToShow?.id
          );

          if (currentIndex >= gallery?.length - 1) {
            setLightBoxDisplay(false);
          } else {
            let nextImage = gallery[currentIndex + 1];
            setImageToShow(nextImage);
          }
        }
      }
    }

    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [imageToShow]);

  const imageCards =
    gallery?.length &&
    gallery.map((image, i) => (
      <div className="col-lg-4 col-md-6 col-sm-12" key={i}>
        <div className="gallery-main">
          <div className="gallery-img">
            <img onClick={() => showImage(image)} src={image?.file} alt="" />
          </div>
          <div className="gallery-title">
            <p className="mb-0">{image?.title}</p>
          </div>
        </div>
      </div>
    ));

  const showImage = (image) => {
    flushSync(() => {
      setImageToShow(image);
    });
    setLightBoxDisplay(true);
  };
  const hideLightBox = () => {
    setLightBoxDisplay(false);
  };
  const showNext = (e) => {
    e.stopPropagation();

    let currentIndex = gallery?.findIndex((ele) => ele?.id == imageToShow?.id);

    if (currentIndex >= gallery?.length - 1) {
      setLightBoxDisplay(false);
    } else {
      let nextImage = gallery[currentIndex + 1];
      setImageToShow(nextImage);
    }
  };
  const showPrev = (e) => {
    e.stopPropagation();

    let currentIndex = gallery?.findIndex((ele) => ele?.id == imageToShow?.id);

    if (currentIndex <= 0) {
      setLightBoxDisplay(false);
    } else {
      let nextImage = gallery[currentIndex - 1];
      setImageToShow(nextImage);
    }
  };

  return (
    <>
      <section className="page-title">
        <div className="container">
          <div className="content-box">
            <div className="content-wrapper">
              <div className="title">
                <h1>Gallery</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      {!gallery?.length ? (
        <>
          <div>
            <div
              className="gallery-sec"
              style={{ backgroundColor: "#6c5ebf1c" }}
            >
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="sec-title text-center mb-4">
                      <div className="sub-title">Gallery</div>
                      <h2 className="mb-4">Our Gallery</h2>
                    </div>
                  </div>
                </div>
                <div className="row mt-5">
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="gallery-main">
                      <div className="gallery-img">
                        <img src={NoImage} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-5">{imageCards}</div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="gallery-sec" style={{ backgroundColor: "#6c5ebf1c" }}>
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="sec-title text-center mb-4">
                    <div className="sub-title">Gallery</div>
                    <h2 className="mb-4">Our Gallery</h2>
                  </div>
                </div>
              </div>
              <div className="row mt-5">{imageCards}</div>
            </div>
          </div>
        </>
      )}

      {lightboxDisplay && (
        <div id="light-box" onClick={hideLightBox}>
          <button onClick={showPrev}>
            <AiOutlineArrowLeft />
          </button>
          <div style={{ position: "relative" }}>
            <img id="light-box-img" src={imageToShow?.file} alt="" />
            <div className="gallery-title">
              <p className="mb-0">{imageToShow?.title}</p>
            </div>
          </div>

          <button onClick={showNext}>
            <AiOutlineArrowRight />
          </button>
        </div>
      )}
    </>
  );
};
